import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, unref as _unref, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "footer-partner-links" };
import PButton from 'primevue/button';
import PartnerAllyIcon from '../assets/icons/partner-ally.svg';
import PartnerAthenaIcon from '../assets/icons/partner-athena.svg';
import PartnerAtnIcon from '../assets/icons/partner-atn.svg';
import PartnerEdxIcon from '../assets/icons/partner-edx.svg';
import { vDataLink } from '../utils/data-link-directive';
import NamedIcon from './named-icon.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'footer-partner-links',
    props: {
        links: { default: () => [{
                    url: 'https://about.curtin.edu.au/learning-teaching/empowering-people/athena-swan/',
                    iconName: PartnerAthenaIcon.id,
                    ariaLabel: 'Visit the Athena Swan page on Curtin University website'
                }, {
                    url: 'https://students.curtin.edu.au/personal-support/lgbtiq/support/',
                    iconName: PartnerAllyIcon.id,
                    ariaLabel: 'Visit the LGBTQIA+ support page on Curtin University website',
                    maxWidth: '5.9375rem'
                }, {
                    url: 'https://www.atn.edu.au/',
                    iconName: PartnerAtnIcon.id,
                    ariaLabel: 'Visit the Australian Technology Network website'
                }, {
                    url: 'https://www.edx.org/school/curtinx',
                    iconName: PartnerEdxIcon.id,
                    ariaLabel: 'Visit Curtin courses on edX'
                }] }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _renderSlot(_ctx.$slots, "default", {}, () => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
                        return _withDirectives((_openBlock(), _createBlock(_unref(PButton), {
                            key: link.url,
                            as: "a",
                            variant: "text",
                            severity: "tertiary",
                            href: link.url,
                            title: link.tooltip,
                            "aria-label": link.ariaLabel,
                            style: _normalizeStyle(link.maxWidth ? { 'max-width': link.maxWidth } : undefined),
                            rel: "noopener",
                            class: "footer-partner-link"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(NamedIcon, {
                                    name: link.iconName,
                                    "aria-hidden": true
                                }, null, 8, ["name"])
                            ]),
                            _: 2
                        }, 1032, ["href", "title", "aria-label", "style"])), [
                            [_unref(vDataLink), { area: 'oasis-footer', category: 'partner-link', link }]
                        ]);
                    }), 128))
                ])
            ]));
        };
    }
});
